import { css } from 'linaria';

export const uniqueOfferContainer = css`
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  display: flex;

  @media (--to-tablet) {
    padding: var(--space-200);
  }
`;

export const uniqueOfferTitle = css`
  margin-bottom: var(--space-200);
`;

export const gridItem = css`
  min-width: 0;
  height: 94px !important;
`;

export const gridContainer = css`
  display: grid;
  gap: var(--space-150);
  width: 100%;
  box-sizing: border-box;

  @media (--from-tablet) {
    &[data-items-count='3'],
    &[data-items-count='5'],
    &[data-items-count='6'] {
      grid-template-columns: repeat(3, 1fr);
    }
    &[data-items-count='2'],
    &[data-items-count='4'] {
      grid-template-columns: repeat(2, 1fr);
    }
    &[data-items-count='1'] {
      grid-template-columns: 2fr 1fr;
    }
  }

  @media (--only-mobile) {
    &[data-items-count='2'],
    &[data-items-count='3'],
    &[data-items-count='4'],
    &[data-items-count='5'],
    &[data-items-count='6'] {
      grid-template-columns: repeat(2, 1fr);
    }
    &[data-items-count='1'] {
      grid-template-columns: 1fr;
    }
    &[data-items-count='3'] .${gridItem}:last-child, &[data-items-count='5'] .${gridItem}:last-child {
      grid-column: span 2;
    }
  }
`;

export const uniqueOfferItemContainer = css`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: var(--rounding-l);
  padding: var(--space-150) !important;
  --button-bg: var(--background-secondary) !important;
`;

export const uniqueOfferItemTextContainer = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: var(--space-100);
`;

export const uniqueOfferItemImage = css`
  align-self: flex-start;
  height: 29px;
  width: 34px;
`;

export const uniqueOfferItemText = css`
  text-wrap: auto;
  text-align: left;
`;

export const uniqueOfferModalImage = css`
  width: 100%;
  height: 140px;
  margin-top: var(--space-1000);

  @media (--only-mobile) {
    margin-top: var(--space-600);
  }
`;

export const uniqueOfferModalHeader = css`
  padding-top: var(--space-300);
`;

export const uniqueOfferModalActionButton = css`
  padding: var(--space-150) var(--space-300) !important;
  font-size: 17px !important;
  line-height: 23px !important;
`;
